import React, { PureComponent } from "react";
import { Redirect } from "react-router-dom";
import { Component } from "react";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import $ from "jquery";
import Cookies from "js-cookie";

// export const getBoardDetails = async (attribute_set_key) => {
//   const tattleDetails = getCommonData();
//   let userdetails = {};
//   if (attribute_set_key) {
//     const response = await fetch(
//       `${decryptconfigdata("apiUrl")}board-details`,
//       {
//         method: "post",
//         body: JSON.stringify({
//           app_token: tattleDetails.data.app_token,
//           attribute_set_key: attribute_set_key,
//         }),
//       }
//     );
//     const jsondata = await response.json();
//     if (jsondata.code === 200) {
//       userdetails = { ...jsondata.data[0] };
//     }
//   }

//   return userdetails;
// };
export const hexToRgba = (hex, opacity) => {
  const key = hex;
  const colors = {
    success: "#28A745",
    secondary: "#6C757D",
    primary: "#007BFF",
    danger: "#DC3545",
    warning: "#FFC107",
    info: "#17A2B8",
    light: "#F8F9FA",
    dark: "#343A40",
  };
  hex = colors[hex]?.replace("#", "");
  var r = parseInt(hex?.substring(0, 2), 16);
  var g = parseInt(hex?.substring(2, 4), 16);
  var b = parseInt(hex?.substring(4, 6), 16);

  return {
    color: hex,
    key,
    backgroundColor: `rgba(${r},${g},${b},${opacity})`,
    borderColor: `rgba(${r},${g},${b},0.5)`,
  };
};
export function getRandomColor() {
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const getCommonData = () => {
  const access_token = localStorage.getItem("token");
  const app_token = localStorage.getItem("app_token");
  const user_uuid = localStorage.getItem("user_uuid");
  const is_admin = localStorage.getItem("is_admin");
  const user_details = localStorage.getItem("user_details");
  const apiUrl = decryptconfigdata("apiUrl");

  return { app_token, user_uuid, is_admin, apiUrl, user_details, access_token };
};

export function commonData() {
  var data = {};
  var has_local_data = getFromStorage("encdata") ? 1 : 0;
  var localdata = has_local_data ? decrypt(getFromStorage("encdata"), 0) : "";
  var apiUrl = decryptconfigdata("apiUrl");
  var user_name = has_local_data ? localdata.data?.name : "";
  var attachment = has_local_data ? localdata.attachment : "";
  var emp_first_name = has_local_data
    ? localdata.data?.name.charAt(0).toUpperCase()
    : "";
  var userAuthKey = has_local_data ? localdata.data?.user_key : "";
  var userId = has_local_data ? localdata.data?.user_uuid : "";
  var productKey = has_local_data ? localdata.data?.product_key : "";
  var appToken = getFromStorage("app_token");
  var userEmail = has_local_data ? localdata.data?.email : "";
  var token = has_local_data ? localdata.response : "";
  var role = has_local_data ? localdata.data.role : [];

  data.apiUrl = apiUrl;
  data.role = role;
  data.token = token;
  data.userAuthKey = userAuthKey;
  data.userEmail = userEmail;
  data.appToken = appToken;
  data.productKey = productKey;
  data.userId = getFromStorage("user_uuid");
  data.user_name = user_name;
  data.emp_first_name = emp_first_name;

  return data;
}

function decryptconfigdata(configkey) {
  var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
  var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
  var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, { iv });
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  return plaintext;
}
export function decrypt(findresponse, flg) {
  var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
  var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
  var res = flg ? findresponse.encdata : findresponse;
  var bytes = CryptoJS.AES.decrypt(res, key, { iv: iv });
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(plaintext);
}
export const firstUpper = (text) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};
function encrypt(data) {
  data = JSON.stringify(data);
  var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
  var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
  var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv });
  return encrypted;
}
function getFromStorage(key) {
  return localStorage.getItem(key.toString());
}

export const getCommonDa = () => {
  const app_token = localStorage.getItem("app_token");
  const user_uuid = localStorage.getItem("user_uuid");
  const is_admin = localStorage.getItem("is_admin");

  return { app_token, user_uuid, is_admin };
};

export const setToStorage = (key, value) => {
  localStorage.setItem(key, value);
};
export const IsJsonString = (str) => {
  try {
    var json = JSON.parse(str);
    return typeof json === "object";
  } catch (e) {
    return false;
  }
};
class Common extends PureComponent {
  constructor(props) {
    super(props);

    var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(this.getFromStorage("encdata"), 0)
      : "";

    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      appToken: has_local_data ? localdata?.data?.app_token : "",
      tattle_token: has_local_data ? localdata.token : "",
    };
  }

  getBoardDetails = async (attribute_set_key) => {
    const tattleDetails = getFromStorage("app_token");
    let userdetails = {};
    if (attribute_set_key) {
      const response = await fetch(`${this.state.apiUrl}board-details`, {
        method: "post",
        body: JSON.stringify({
          app_token: tattleDetails,
          attribute_set_key: attribute_set_key,
          user_uuid: this.getCommonData().user_uuid,
        }),
      });
      const jsondata = await response.json();
      if (jsondata.code === 200) {
        userdetails = { ...jsondata.data[0] };
      }
    }

    return userdetails;
  };

  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, { iv });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }
  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, { iv: iv });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }
  encrypt(data) {
    data = JSON.stringify(data);
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv });
    return encrypted;
  }
  IsJsonString = (str) => {
    try {
      var json = JSON.parse(str);
      return typeof json === "object";
    } catch (e) {
      return false;
    }
  };

  logout() {
    this.setToStorage("userLogin", "");
    localStorage.clear();
    Cookies.remove("token", {
      path: "/",
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    }); // removed!
    setTimeout(() => {
      window.location.href = process.env.REACT_APP_LOCAL_URL_REDIRECT;
    }, 2000);
    return false;
    //window.location.href = '/login';
  }

  setToStorage(key, value) {
    localStorage.setItem(key, value);
  }
  getFromStorage(key) {
    return localStorage.getItem(key.toString());
  }

  firstUpper = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  async checklogion() {
    var returnVal = false;
    if (this.getFromStorage("userLogin") === "yes") {
      var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
      var localdata = has_local_data
        ? this.decrypt(this.getFromStorage("encdata"), 0)
        : "";
      returnVal = true;
    }

    if (!returnVal) {
      // this.setToStorage("encdata", "");
      // this.setToStorage("token", "");
      this.setToStorage("userLogin", "");
    }
    return returnVal;
  }

  getCommonData = () => {
    const access_token = localStorage.getItem("token");
    const app_token = localStorage.getItem("app_token");
    const user_uuid = localStorage.getItem("user_uuid");
    const is_admin = localStorage.getItem("is_admin");
    const user_details = localStorage.getItem("user_details");
    const apiUrl = decryptconfigdata("apiUrl");

    return {
      app_token,
      user_uuid,
      is_admin,
      apiUrl,
      user_details,
      access_token,
    };
  };
}
export default Common;
